import appPending from "../../../assets/application-pending.svg";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import AppProgressBar from "../../../Common/progressBar";
import { motionContainer } from "../../../pages/partner-enrollment";
import { AnimatePresence, motion } from "framer-motion";

function PartnerApplicationStatusReview({ progressPercent = 0 }) {
  const navigate = useNavigate();
  const onLogout = () => {
    Auth.signOut().then((res) => {
      navigate("/login");
    });
  };
  return (
    <AnimatePresence mode="wait">
      <Container className="mt-3 mb-5">
        <Row className="justify-content-center">
          <Col md={10} className="content-box pt-5 pb-5 px-lg-5">
            <AppProgressBar progressPercent={progressPercent} />
            <motion.div key={"review"} {...motionContainer}>
              <Row className="px-lg-5 justify-content-center align-items-center">
                <Col lg={7}>
                  <h1 className="content-box-heading mb-3 fs-4">
                    Your Application is Pending Approval
                  </h1>
                  <p className="content-text">
                    Thank you for applying for our Partner Program. We are
                    currently processing and reviewing your application. You will be
                    notified by email when we are finished.
                  </p>
                  <div className="d-flex mt-5 align-items-center">
                    <button onClick={onLogout} className="btn-continue">
                      Log Out
                    </button>
                  </div>
                </Col>
                <Col lg={5}>
                  <img src={appPending} alt="Tax-report" className="img-fluid pt-4" />
                </Col>
              </Row>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </AnimatePresence>
  );
}

export default PartnerApplicationStatusReview;